import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    fechaLiquidacion: moment(new Date()).format('YYYY-MM-DD'),
    personalId: 0,
    personal: null,
    personalNombre: null,
    liquidacionFinal: 0,
    observaciones: '',
    importeReadOnly: false
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, liquidacionFinalId) {
        state.id = liquidacionFinalId;
        state.fechaLiquidacion = moment(new Date()).format('YYYY-MM-DD');
        state.personalId = 0;
        state.personal = null;
        state.personalNombre = null;
        state.liquidacionFinal = 0;
        state.observaciones = '';
        state.importeReadOnly = false;
    },
    'SET_LIQUIDACION_FINAL' (state, liquidacionFinal) {
        state.fechaLiquidacion = moment(liquidacionFinal.fechaLiquidacion).format('YYYY-MM-DD');
        state.observaciones = liquidacionFinal.observaciones;
        if (liquidacionFinal.liquidacionesPersonal) {
            if (liquidacionFinal.liquidacionesPersonal.length != 0) {
                let liquidacion = liquidacionFinal.liquidacionesPersonal[0];

                if (liquidacion) {
                    state.personalId = liquidacion.personalId;
                    state.personal = {
                        id: liquidacion.personalId,
                        nombre: liquidacion.personal
                    };
                    state.personalNombre = liquidacion.personal;
                    state.liquidacionFinal = liquidacion.liquidacionFinal;
                    // state.importeReadOnly = (/true/i).test(liquidacion.liquidacionFinalReadOnly);
                    state.importeReadOnly = (/true/i).test(liquidacion.readOnly);
                }
            }
        }
    },
    'SET_PERSONAL'(state, personal) {
        state.personal = personal;
        if (personal) {
            state.personalId = personal.id? personal.id : 0;
            state.personalNombre = personal.nombre? personal.nombre.trim() : null;
        } else {
            state.personalId = 0;
            state.personalNombre = null;
        }
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, liquidacionFinalId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', liquidacionFinalId);

            if (liquidacionFinalId != 0) {
                apiAxios.get(`liquidaciones-sueldos/${liquidacionFinalId}/abm`)
                    .then(res => {
                        commit('SET_LIQUIDACION_FINAL', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
            // } else {
            //     reject(errorMessage);
            // }
        })

    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';
            
            if (save) {
                let liquidacionesPersonal = [{
                    personalId: parseInt(state.personalId),
                    liquidacionFinal: parseFloat(state.liquidacionFinal),
                }];

                let liquidacion = {
                    fechaLiquidacion: moment(state.fechaLiquidacion).format('YYYY-MM-DD'),
                    liquidacionFinal: true,
                    observaciones: state.observaciones.trim(),
                    liquidacionesPersonal
                };

                let url = 'liquidaciones-sueldos';
                if (state.id != 0) {
                    url += '/' + state.id;
                }

                apiAxios.post(url, liquidacion)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
    setPersonal: ({ commit }, personal) => {
        commit('SET_PERSONAL', personal);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}